import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Controller } from "../interface/controller.interface";
import { HTTPMethod } from "../model/http-method.enum";
import { HTTPRequestBuilder } from "../model/http.request.model";
import { HTTPService } from "./http.service";
import { orElse } from "../model/operator/or-else.operator";
import { OrderEventType } from "../persistence/dto/order-event-type.model";

	/**
	 * @description
	 *	Servicio reflejo del controlador de causas de CyR
	 *	(cambios y reclamos), y NC (notas de crédito), del backend.
	 *
	 * @see gigot-backend/Controllers/Orders/OrderEventTypeController.cs
	 */

@Injectable({ providedIn: "root" })
export class OrderEventTypeService implements Controller {

	constructor(private httpService: HTTPService) {}

	public basePath(): string {
		return "api/orderEventType";
	}

	public allTypes(): Observable<OrderEventType[]> {
		return this.httpService.send<typeof undefined, OrderEventType[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
				.relativePath("")
				.build())
			.pipe(
				orElse<OrderEventType[]>([] as OrderEventType[]),
				map(orderEventTypes => orderEventTypes.map(orderEventType => OrderEventType.from(orderEventType))));
	}
}
